import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupPeriodoCursada } from '../PeriodoCursada/LookupPeriodoCursada';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddCursada extends Component {
  static displayName = AddCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      anioDictado: '',
      dictado: '',
      errorMessage: '',
      redirect: false,
      materia: { materiaCarreraCodigo: '', descripcion: '' },
      cursada: { cursadacod: '', cursadadescripcion: '' },
      showLookupMaterias: false,
      showLookupPeriodoCursada: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWCursada');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    const dictado = carreraProperties[4];
    this.clearFeedback();
    this.setState({
      showLookupMaterias: false,
      dictado,
      materia: {
        materiaCarreraCodigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2] + ' - ' + carreraProperties[3],
      },
    });
  };

  handleSelectPeriodoCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const periodo = carreraProperties[3];
    this.clearFeedback();
    this.setState({
      showLookupPeriodoCursada: false,
      anioDictado: periodo,
      cursada: {
        cursadacod: carreraProperties[0],
        cursadadescripcion: carreraProperties[1] + ' - ' + carreraProperties[2],
      },
    });
  };

  handleHideMateriaLookup = () => {
    this.setState({ showLookupMaterias: false });
  };

  handleHidePeriodoCursadaLookup = () => {
    this.setState({ showLookupPeriodoCursada: false });
  };

  handleShowMateriaLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMaterias: true });
    }
  };

  handleShowPeriodoCursadaLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupPeriodoCursada: true });
    }
  };

  isFormValid() {
    return (
      this.state.materia.descripcion.length > 0
      && this.state.cursada.cursadadescripcion.length > 0
    );
  }

  isDictadoValid() {
    return this.state.dictado === this.state.anioDictado;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }

    if (!this.isDictadoValid()) {
      this.setState({
        errorMessage: 'La materia seleccionada no se dicta en el período seleccionado.',
      });
      return;
    }

    this.saveCursada();
  }

  async saveCursada() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/cur', {
      method: 'POST',
      body: JSON.stringify({
        MateriaCarreraCod: this.state.materia.materiaCarreraCodigo,
        PeriodoCursadaCod: this.state.cursada.cursadacod,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar la cursada. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-cur" />;
    }

    const {
      loading,
      materia,
      cursada,
      showLookupMaterias,
      showLookupPeriodoCursada,
      errorMessage,
    } = this.state;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-cur">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Cursada</h1>
        <p className="md-form-page__subtitle">
          Seleccione la materia y el período de cursada para registrar una nueva cursada.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando cursada, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowMateriaLookup}
                disabled={loading}
              >
                Seleccione la Materia
              </button>
              {showLookupMaterias ? (
                <LookupMaterias
                  selectItem={this.handleSelectCarreraItem}
                  hideLookup={this.handleHideMateriaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materia.descripcion}
                placeholder="Materia seleccionada"
                readOnly
                disabled
                aria-label="Materia seleccionada"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Cursada</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowPeriodoCursadaLookup}
                disabled={loading}
              >
                Seleccione el Período de Cursada
              </button>
              {showLookupPeriodoCursada ? (
                <LookupPeriodoCursada
                  selectItem={this.handleSelectPeriodoCursadaItem}
                  hideLookup={this.handleHidePeriodoCursadaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={cursada.cursadadescripcion}
                placeholder="Período de cursada seleccionado"
                readOnly
                disabled
                aria-label="Período de cursada seleccionado"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
